import React, { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';

interface EntityContextProps {
  selectedEntity: string | null;
  setSelectedEntity: Dispatch<SetStateAction<string | null>>;
}

const EntityContext = createContext<EntityContextProps | undefined>(undefined);

export const EntityProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedEntity, setSelectedEntity] = useState<string | null>(null);

  return (
    <EntityContext.Provider value={{ selectedEntity, setSelectedEntity }}>
      {children}
    </EntityContext.Provider>
  );
};

export const useEntity = (): EntityContextProps => {
  const context = useContext(EntityContext);
  if (!context) {
    throw new Error('useEntity must be used within an EntityProvider');
  }
  return context;
};
